import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Countdown } from '../ui/Countdown';
import { trackInitiateCheckout } from '../MetaPixel';
import { Lock, Zap, ShieldCheck, CreditCard } from 'lucide-react';
interface PricingSectionProps {
  id?: string;
  isReprise?: boolean;
}
type PackId = 'profesional' | 'elite';
const PACKS = {
  profesional: {
    id: 'profesional' as PackId,
    icon: '📘',
    name: 'PACK PROFESIONAL',
    description: '12 Tomos + 6 Bonus',
    priceOld: '$29.990',
    price: '$18.990',
    url: 'https://profelisto.com.ar/checkouts/cn/hWNEBkV2CoNcjeMbJaMhWV0M/es-ar?_r=AQAB7JsSGxqljOkDquS938jQ_cAUyl3UbStJa-UEIeEIWQk',
    cta: 'SÍ, QUIERO EL PACK PROFESIONAL →'
  },
  elite: {
    id: 'elite' as PackId,
    icon: '🏆',
    name: 'MEGAPACK ÉLITE',
    description: '12 Tomos + 6 Bonus + 2 EBOOKS ÉLITE',
    priceOld: '$49.990',
    price: '$27.990',
    url: 'https://profelisto.com.ar/checkouts/cn/hWNEBkVJBKwNHP4PrMvumqgc/es-ar?_r=AQAB0FZhTAdkUfQPXhz9EjzZneo5O0iF9IAbS6I0CJH6CZs',
    cta: 'SÍ, QUIERO EL MEGAPACK ÉLITE →'
  }
};
export function PricingSection({
  id,
  isReprise = false
}: PricingSectionProps) {
  const [selected, setSelected] = useState<PackId>('elite');
  const handleCheckout = () => {
    trackInitiateCheckout(selected);
    window.location.href = PACKS[selected].url;
  };
  return <section id={id} className="py-20 px-4 bg-oscuro relative overflow-hidden" data-id="element-156">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-157">
        {/* Countdown header */}
        <div className="text-center mb-10" data-id="element-158">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-extrabold text-red-500 mb-6" data-id="element-159">
            {isReprise ? '⏰ El precio de lanzamiento cierra en:' : '⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO'}
          </motion.h2>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="mb-4" data-id="element-160">
            <Countdown data-id="element-161" />
          </motion.div>

          {!isReprise && <p className="text-white/80 text-base font-medium" data-id="element-162">
              🔴 El precio sube cuando termina el contador
            </p>}
        </div>

        {/* Checkout card */}
        <motion.div id="elegi-tu-pack" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-2xl p-6 md:p-10 scroll-mt-6" data-id="element-163">
          <h3 className="text-2xl md:text-4xl font-extrabold text-oscuro text-center mb-2" data-id="element-164">
            Elegí tu Pack:
          </h3>
          <p className="text-center text-gray-500 mb-8 text-sm md:text-base" data-id="element-165">
            Ambas opciones incluyen los 6 Bonus estratégicos
          </p>

          {/* Options */}
          <div className="space-y-3 mb-6" data-id="element-166">
            {(['profesional', 'elite'] as PackId[]).map(packId => {
            const pack = PACKS[packId];
            const isSelected = selected === packId;
            const isElite = packId === 'elite';
            return <button key={packId} type="button" onClick={() => setSelected(packId)} className={`w-full text-left rounded-2xl border-2 transition-all duration-200 p-4 md:p-5 flex items-center gap-3 md:gap-4 ${isSelected ? 'border-terracota bg-terracota/5 shadow-sm' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-167">
                  <div className={`flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-terracota' : 'border-gray-300'}`} data-id="element-168">
                    {isSelected && <div className="w-3 h-3 rounded-full bg-terracota" data-id="element-169" />}
                  </div>

                  <div className="flex-1 min-w-0" data-id="element-170">
                    <div className="flex flex-wrap items-center gap-2 mb-1" data-id="element-171">
                      <span className="font-extrabold text-oscuro text-sm md:text-lg flex items-center gap-1.5" data-id="element-172">
                        <span data-id="element-173">{pack.icon}</span>
                        {pack.name}
                      </span>
                      {isElite && <>
                          <span className="inline-flex items-center gap-1 bg-dorado text-oscuro text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-174">
                            ⭐ MÁS ELEGIDO
                          </span>
                          <span className="inline-flex items-center bg-terracota/10 text-terracota text-[10px] md:text-xs font-bold px-2 py-0.5 rounded-full" data-id="element-175">
                            AHORRÁS $10.000
                          </span>
                        </>}
                    </div>
                    <p className="text-gray-500 text-xs md:text-sm" data-id="element-176">
                      {pack.description}
                    </p>
                  </div>

                  <div className="text-right flex-shrink-0" data-id="element-177">
                    <p className="text-gray-400 line-through text-xs md:text-sm" data-id="element-178">
                      {pack.priceOld}
                    </p>
                    <p className={`font-extrabold text-lg md:text-2xl ${isElite ? 'text-terracota' : 'text-oscuro'}`} data-id="element-179">
                      {pack.price}
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <motion.button type="button" onClick={handleCheckout} animate={{
          scale: [1, 1.03, 1],
          boxShadow: ['0 10px 15px -3px rgba(201, 123, 90, 0.3)', '0 12px 28px -2px rgba(201, 123, 90, 0.6)', '0 10px 15px -3px rgba(201, 123, 90, 0.3)']
        }} transition={{
          duration: 1.2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} whileTap={{
          scale: 0.98
        }} whileHover={{
          scale: 1.04
        }} className="w-full bg-terracota hover:bg-terracota-dark text-white font-extrabold py-5 px-6 rounded-2xl text-base md:text-xl transition-colors duration-200" data-id="element-180">
            {PACKS[selected].cta}
          </motion.button>

          <p className="text-center text-gray-400 italic text-xs md:text-sm mt-4" data-id="element-181">
            {selected === 'elite' ? 'La opción más elegida por profesores de yoga argentinos' : 'Acceso inmediato luego del pago'}
          </p>
        </motion.div>

        {/* Trust badges */}
        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4" data-id="element-182">
          {[{
          icon: <Lock size={18} data-id="element-183" />,
          label: 'Pago seguro'
        }, {
          icon: <Zap size={18} className="text-dorado" data-id="element-184" />,
          label: 'Acceso en 5 min'
        }, {
          icon: <ShieldCheck size={18} className="text-salvia" data-id="element-185" />,
          label: 'Garantía 7 días'
        }, {
          icon: <CreditCard size={18} data-id="element-186" />,
          label: 'Tarjeta · Transferencia'
        }].map((badge, idx) => <div key={idx} className="flex items-center justify-center md:justify-start gap-2 text-white/80 text-xs md:text-sm font-medium" data-id="element-187">
              <span className="text-white" data-id="element-188">{badge.icon}</span>
              {badge.label}
            </div>)}
        </div>
      </div>
    </section>;
}